import { useNavigate } from 'react-router-dom';

// material-ui
import { useTheme } from '@mui/material/styles';
import Box from '@mui/material/Box';
import Avatar from '@mui/material/Avatar';
import Typography from '@mui/material/Typography';
import ListItemButton from '@mui/material/ListItemButton';
import ListItemIcon from '@mui/material/ListItemIcon';
import ListItemText from '@mui/material/ListItemText';
import Stack from '@mui/material/Stack';

// project import
import { useGetMenuMaster } from 'services/menu';
import tokenUtil from 'utils/token';

// assets
import LogoutOutlined from '@ant-design/icons/LogoutOutlined';

export default function NavUser() {
  const theme = useTheme();
  const navigate = useNavigate();
  const { menuMaster } = useGetMenuMaster();
  const drawerOpen = menuMaster.isDashboardDrawerOpened;

  const handleLogout = () => {
    tokenUtil.removeToken();
    try {
      localStorage.removeItem('currentUser');
    } catch (err) {}
    navigate('/login');
  };

  // Get current user data
  let currentUser = null;
  try {
    const raw = localStorage.getItem('currentUser');
    if (raw) currentUser = JSON.parse(raw);
  } catch (err) {
    // ignore
  }

  const initial = currentUser?.name ? currentUser.name.charAt(0).toUpperCase() : 'U';

  return (
    <Box sx={{ p: 2, borderTop: `1px solid ${theme.palette.divider}` }}>
      {/* User Info Section */}
      <Stack direction="row" spacing={1.5} alignItems="center" sx={{ mb: 2, pl: 0.5 }}>
        <Avatar
          sx={{
            width: 36,
            height: 36,
            bgcolor: '#e5e7eb',
            color: 'black',
            fontSize: '1rem'
          }}
        >
          {initial}
        </Avatar>
        {drawerOpen && (
          <Stack spacing={0}>
            <Typography variant="subtitle1" sx={{ color: 'text.primary', fontWeight: 600, lineHeight: 1.2 }}>
              {currentUser?.name || 'User'}
            </Typography>
            <Typography variant="caption" sx={{ color: 'text.secondary' }}>
              {currentUser?.role || 'Member'}
            </Typography>
          </Stack>
        )}
      </Stack>

      {/* Logout Button */}
      <ListItemButton
        onClick={handleLogout}
        sx={{
          px: 1,
          py: 0.5,
          borderRadius: 1,
          '&:hover': {
            bgcolor: 'action.hover',
            color: 'error.main' // Optional: make logout red on hover
          }
        }}
      >
        <ListItemIcon sx={{ minWidth: 32 }}>
          <LogoutOutlined style={{ fontSize: '1.25rem' }} />
        </ListItemIcon>
        {drawerOpen && <ListItemText primary="Log Out" primaryTypographyProps={{ variant: 'body1', color: 'text.primary' }} />}
      </ListItemButton>
    </Box>
  );
}
